import React from 'react';
import GumballIcon from './GumballIcon';

const ITEMS = [
  { href: '/', label: 'Home', icon: 'home' },
  { href: '#about', label: 'About', icon: 'about', awayHref: '/#about' },
  { href: '#roadmap', label: 'Roadmap', icon: 'roadmap', awayHref: '/#roadmap', roadmapHref: '/roadmap' },
  { href: '#socials', label: 'Community', icon: 'community', awayHref: '/#socials' },
];

export function MobileMenuLinks({ onHomepage = false, extraItems = [] }) {
  const resolveHref = (item) => {
    if (onHomepage) return item.href;
    if (item.href === '#roadmap') return '/roadmap';
    return item.awayHref || item.href;
  };

  return (
    <>
      {ITEMS.map((item) => (
        <li key={item.label}>
          <a href={resolveHref(item)} className="menu-link menu-pill">
            <span className="menu-pill-icon">
              <GumballIcon name={item.icon} size={18} />
            </span>
            {item.label}
          </a>
        </li>
      ))}
      {extraItems.map((item) => (
        <li key={item.label}>
          <a href={item.href} className="menu-link menu-pill">
            <span className="menu-pill-icon">
              <GumballIcon name={item.icon} size={18} />
            </span>
            {item.label}
          </a>
        </li>
      ))}
    </>
  );
}
